module.exports = __webpack_public_path__ + "img/03.b20d57eb.jpg";